import { gql } from '@apollo/client'

export const CHANGE_BOOKING_SCHEDULER_CONTROL_STATUS = gql`
  mutation ChangeBookingSchedulerControlStatus($schedulerType: String!, $bookingId: Long!) {
    changeBookingSchedulerControlState(schedulerType: $schedulerType, bookingId: $bookingId) {
      schedulerType
      isEnabledForBooking
    }
  }
`